<template>
  <div id="videoplayer" class="video2 u-row u-center u-relative u-marg-t-lg">
    <div class="u-w8of12 u-relative u-w12of12--sm">
      <div class="u-box-16by9 u-box-1by1--xs">
        <!-- <div class="u-wrapper-panel">
          <img class="u-fit-cover" src="/images/video.jpg">
        </div> -->
        <youtube-player 
          :isPlaying="isPlaying"
          poster="/images/video.jpg"
          class="u-wrapper-panel u-row u-center u-middle"
          :id="$i18n.locale === 'fr' ? 'hCoWQz5ymcw' : 'WMF3v6QkkxA'"
        >
          <anim-scroll>
            <cta>
              <div class="u-flex u-middle">
                {{ $t('video.cta') }} 
                <svg class="t-icon t-fill-black u-marg-l-sm">
                  <use xlink:href="#arrow-right"/>
                </svg>
              </div>
            </cta>
          </anim-scroll>
        </youtube-player>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cta from '@/components/common/Cta'
import YoutubePlayer from '@/components/common/YoutubePlayer'
import AnimScroll from '@/components/common/AnimScroll'

export default {
  components: {
    Cta,
    YoutubePlayer,
    AnimScroll
  },
  data () {
    return {
      isPlaying: false
    }
  },
  created () {
    this.$hub.on('playVideo', ()=>{
      this.isPlaying = true
    })
  }
}
</script>

<style lang="stylus" scroped>

@import '~@/styles/settings/variables'

.video2 
  &:before
    content ''
    position absolute
    bottom 0
    left 0
    width 100%
    height 50%
    background-color $colors.black
</style>